<template>

    <div>
        <div class="row  no-gutters pt-xl-4 mb-xl-6">
            <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
                 v-if="lesson">
                {{lesson.lesson}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points">
                <div class="zerno-points">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1">{{ $t('test') }} {{$t('№')}}{{ test.pos }}
                    <span class="ml-2" v-if="testsCount > 0">({{test.pos}} {{$t('of')}} {{testsCount}})</span>
                </div>
            </div>

            <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

                <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
                <h2 class="mt-7" v-else>{{ $t('test') }} {{$t('№')}}{{ test.pos }}</h2>
                <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
                <button
                        class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                        @click="startTest">
                    <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{$t('№')}}{{ test.pos }}
                </button>

            </div>

            <div class="col-12 order-10" v-if="!showTestIntro && test">
                <div class="row justify-content-center mb-4">
                    <div class="col-12 display-3 text-center">
                        Скорее найди:
                    </div>
                    <div class="col-12 display-1 text-center">
                       {{ findLetters }}
                    </div>
                    <div class="col-6 offset-3 text-center">
                        <p>Используй слайдер, чтобы изменить размер текста</p>
                        <base-slider v-model="slider" :range="{min: 6, max: 50}" :disabled="false" class="mx-12" style="width: 100%;"></base-slider>
                    </div>
                    <div class="col-3" />
                </div>


                <div class="row justify-content-center mb-4">
                    <div class="col-12 h3 text-center">Твое время: {{timerText}}</div>
                    <div v-for="(row, i) in rows" :key="i" class="col-12 d-flex flex-wrap h3 justify-content-center text-center" style="cursor: pointer;">
                        <span
                            :style="'font-size: ' + parseInt(slider) + 'px'"
                            v-for="(item, j) in row"
                            :key="j"
                            :class="['mr-1', upturned?'upturned':'', item.color ]"
                            @click="itemClick(item)"
                        >{{item.text}}</span>
                    </div>
                </div>


                <div class="row">
                    <div v-if="result=='correct'" class="col-12 mb-4 text-center">
                        <img src="poliimg/excellent.png"
                             class="test-image"
                             style="width: 250px"
                        >
                        <p class="text-center">Найдено: {{ correctCount }} из {{ searchedCount }}</p>
                        <p v-if="errorsCount" class="text-center">Ошибочно отмечено: {{ errorsCount }}</p>
                    </div>
                    <div v-if="result=='wrong'" class="col-12 mb-4">
                        <div class="text-center">
                            <img src="poliimg/oops2.png"
                                class="test-image"
                                style="width: 250px"
                            >
                        </div>
                        <p class="text-center">Ничего не найдено!</p>
                    </div>

                    <div class="col-12 mb-4 justify-content-center d-flex">
                        <div>
                            <button
                                    v-if="!result"
                                    class="btn btn-secondary"
                                    @click="doAnswer()">
                                    Ответить
                            </button>
                            <button
                                    v-if="!!result"
                                    class="btn btn-secondary"
                                    @click="nextTask()">
                                    Далее
                            </button>
                        </div>
                    </div>
                </div>


            </div>


        </div>
        <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
            <button
                    class="btn btn-info"
                    @click="skip"
            >
                {{ $t('omit_task') }} &rarr;
            </button>
        </div>
    </div>


</template>

<style>
    .v-chip__content {
        font-size: 40px;
        font-weight: 500;
    }
</style>

<script>
    import Vue from 'vue'
    import api from '@/utils/api'

    export default {
        name: 'Test24',
        props: {
            idtest: {default: null},
            lesson: {type: Object, default: null},
            points: {default: null},
            testsCount: {default: null},
            showButtons: {type: Boolean, default: true},
        },
        data: () => ({
            test: {},
            testtasks: [],
            testelements: [],
            taskIdx: 0,
            mainElement: {},
            findLetters: '',
            audio: new Audio(),
            result: null,
            mode: null,
            items: [],
            rows: [],
            upturned: false,
            searchedCount: 0,
            correctCount: 0,
            errorsCount: 0,
            slider: 32,

            timerSeconds: 0,
            timer: null,

            errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
            okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',
            showTestIntro: true,
        }),

        computed: {
            currentTask: function () {
                console.log('currentTask')
                return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
            },

            timerText() {
                const sec = this.timerSeconds % 60
                const min = Math.trunc(this.timerSeconds / 60)
                return min.toString().padStart(2, "0") + ':' + sec.toString().padStart(2, "0")
            },
        },

        watch: {
            taskIdx: async function () {
                this.loadTask()
            },
        },

        async mounted() {
            document.onselectstart = new Function("return false");
            api({url: '/tests/' + this.idtest}).then(resp => {
                this.test = resp.data
            })
            const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
            this.testtasks = response.data
            this.loading = false
        },
        methods: {
            async startTest() {
                if (this.testtasks.length) {
                    if (this.test.audio) {
                        await this.play(this.test.audio)
                    }
                    this.showTestIntro = false
                    this.loadTask()
                }
            },
            async loadTask() {
                this.result = null
                if (this.currentTask.idtesttask) {
                    const response = await api({
                        method: 'get',
                        url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
                    })
                    this.testelements = response.data
                    this.mainElement = this.testelements.length ? this.testelements[0] : {}
                    this.play(this.mainElement.audio)

                    // реактивность глючит на вложенных уровнях. Выводим в основные переменные
                    this.findLetters = this.mainElement.word2

                    let answers = this.findLetters.toUpperCase().split(/[ |]+/)
                    this.mode = 'letters'
                    answers.forEach(el => { if(el.length>1) this.mode = 'words' })
                    console.log(this.mode)

                    this.items = []
                    this.upturned = this.mainElement.isright == 1
                    this.rows = this.mainElement.word.split(/\|+/)
                    this.searchedCount = 0
                    for (let i = 0; i < this.rows.length; i++) {
                        const arr = this.rows[i].split(this.mode == 'letters' ? '' : /[ \r\n]+/)
                        arr = arr.map((item, index) => ({ text: item, color: '' }))
                        this.rows[i] = arr

                        arr.forEach(el => {
                            el.isCorrect = answers.indexOf(el.text.toUpperCase().replace(/[, \.;:]+/g, '')) > -1
                            if(el.isCorrect) this.searchedCount++
                            this.items.push(el) // hack. Put elements into reactive watched array (but change it into 2D array - this.rows)
                        });
                    }

                    this.startTimer()
                    console.log(this.rows)
                } else {
                    this.$emit('testComplete')
                }
            },
            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            shuffle(a) {
                for (let i = a.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [a[i], a[j]] = [a[j], a[i]]
                }
                return a
            },

            shuffleFull(items) {
                const originalState = items.map(a => ({...a})) // clone

                for (let i = 0; i < 1000; i++) {
                    items = this.shuffle(items)
                    let wrongPlace = false
                    items.forEach((e, i) => {
                        if (e.idtestelement === originalState[i].idtestelement) wrongPlace = true
                    })
                    if (!wrongPlace) {
                        console.log('Shuffle tryes: ' + i)
                        break
                    }
                }

                return items
            },

            play: function (path) {
                return new Promise((resolve) => {
                    if (path) {
                        this.audio.src = path
                        this.audio.play()
                        this.audio.onended = function () {
                            console.log('Звук закончился')
                            resolve()
                        }

                        this.audio.onerror = function () {
                            console.log('Звук error')
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                })
            },

            itemClick (item) {
                /* Ограничение на кол-во отмеченных букв
                if(item.color!='bg-green') {
                    let max = 15
                    for (const i in this.items) {
                        if (this.items[i].color == 'bg-green') max--
                        if(!max) return
                    }
                } */

                Vue.set(item, 'color', item.color=='bg-green'?'':'bg-green')
                console.log(item)
            },


            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },

            doAnswer: async function () {
                this.stopTimer()
                this.correctCount = 0
                this.errorsCount = 0
                for (const i in this.items) {
                        if (this.items[i].color == 'bg-green') {
                            if(this.items[i].isCorrect) {
                                this.$emit('correctAnswer')
                                this.correctCount++
                            } else {
                                Vue.set(this.items[i], 'color', 'bg-red')
                                this.errorsCount++
                            }
                        } else if(this.items[i].isCorrect) {
                            Vue.set(this.items[i], 'color', 'border-green')
                        }
                }

                if(this.correctCount > 0) {
                    this.result = 'correct'
                    if (this.mainElement.audio) {
                        await this.play(this.mainElement.audio)
                    } else {
                        await this.play(this.okChord)
                    }

                } else {
                    this.result = 'wrong'
                    await this.play(this.errorChord)
                }
            },

            skip: function () {
                this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
                this.taskIdx++
            },

            nextTask () {
                this.taskIdx++
            },

            startTimer() {
                if(this.timer !== null) clearTimeout(this.timer)
                this.timerSeconds = 0
                this.timer = setInterval(() => {
                    this.timerSeconds++
                }, 1000)
                console.log('start timer', this.timer)
            },

            stopTimer() {
                clearTimeout(this.timer)
                console.log('stop timer')
            },
        },

        destroyed() {
            this.stopTimer()
        },
    }
</script>
